// extracted by mini-css-extract-plugin
export default {"footerBarContainer":"FooterBar_footerBarContainer__LSROe","footerText":"FooterBar_footerText__RBRR1"};